import { fetchApi } from '@/config/axiosSetting.ts';
import { AddDamagedPersonParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postAddDamagedPerson/addDamagedPersonQuery.type';

export const addDamagedPersonQueryFunction = ({
  formData,
  id,
}: AddDamagedPersonParamsType): Promise<{}> => {
  return fetchApi({
    method: 'post',
    url: `property/reports/${id}/accident_users/damaged/add/`,
    data: formData,
  });
};
